import useGoogleTranslate from './use-google-translate';

export default useGoogleTranslate;